import React, { CSSProperties } from 'react'
import * as RadixAvatar from '@radix-ui/react-avatar'
import { ConditionalWrapper } from '../ConditionalWrapper'

const { Root, Fallback, Image } = RadixAvatar

export interface AvatarProps {
  alt?: string
  fallback?: string
  href?: string
  src?: string
  size?: number
  style?: CSSProperties
  color?: string
}

export const Avatar: React.FC<AvatarProps> = ({
  alt,
  fallback,
  href,
  src,
  size = 45,
  style,
  color
}) => (
  <ConditionalWrapper
    condition={typeof href !== 'undefined' && Boolean(href)}
    wrapper={(children) => <a href={href} target="_blank" rel="noreferrer" style={style}>{children}</a>}
  > 
    <Root style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'middle',
      overflow: 'hidden',
      userSelect: 'none',
      width: size,
      height: size,
      borderRadius: '100%',
      backgroundColor: 'white',
      border: `1px solid ${color || 'var(--slate12)'}`,
      backgroundClip: 'padding-box',
    }}
    >
      <Image
        style={{
          height: '100%',
          objectFit: 'cover',
          borderRadius: 'inherit',
        }}

        src={src}
        alt={alt}
      />
      <Fallback
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          color: 'var(--slate12)',
          fontSize: 15,
          lineHeight: 1,
          fontWeight: 500,
        }}
        delayMs={600}
      >
        {fallback}
      </Fallback>
    </Root>
  </ConditionalWrapper>
)

export default Avatar
